import { gql } from '@apollo/client';
import * as React from 'react';

import { useSupportingContentTabs_OrganizationFragment } from './graphql-types/useSupportingContentTabs_OrganizationFragment';
import { useSupportingContentTabs_SpecialOfferFragment } from './graphql-types/useSupportingContentTabs_SpecialOfferFragment';

import { EMenuItem } from '../../pages/conference/util';

export const useSupportingContentTabs = (options: {
  loading: boolean;
  showPublishedVideo?: boolean;
  disableChat: boolean;
  sponsorOrganization?: useSupportingContentTabs_OrganizationFragment;
  specialOffer?: useSupportingContentTabs_SpecialOfferFragment;
}): {
  validTabs: EMenuItem[];
  activeTab: EMenuItem;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
} => {
  const {
    loading,
    showPublishedVideo,
    disableChat,
    sponsorOrganization,
    specialOffer,
  } = options;
  const hasSponsor =
    !!sponsorOrganization?.sponsorship?.ad || !!specialOffer?.specialOffer;

  const [activeMenuItem, setActiveMenuItem] = React.useState<number>(
    hasSponsor
      ? EMenuItem.SPONSOR
      : showPublishedVideo
      ? EMenuItem.CHAT
      : EMenuItem.ATTENDEES
  );

  React.useEffect(() => {
    if (!loading) {
      if (hasSponsor) {
        setActiveMenuItem(EMenuItem.SPONSOR);
      } else if (showPublishedVideo) {
        setActiveMenuItem(EMenuItem.CHAT);
      }
    }
  }, [loading, hasSponsor, showPublishedVideo]);

  return {
    validTabs: [
      ...(hasSponsor ? [EMenuItem.SPONSOR] : []),
      EMenuItem.INFO,
      ...(showPublishedVideo ? [] : [EMenuItem.ATTENDEES]),
      ...(disableChat ? [] : [EMenuItem.CHAT]),
    ],
    activeTab: activeMenuItem,
    setActiveTab: setActiveMenuItem,
  };
};
useSupportingContentTabs.sponsorOrganizationFragment = gql`
  fragment useSupportingContentTabs_OrganizationFragment on Organization {
    _id
    sponsorship {
      ad {
        _id
      }
    }
  }
`;
useSupportingContentTabs.specialOfferFragment = gql`
  fragment useSupportingContentTabs_SpecialOfferFragment on ConferenceBooth {
    _id
    specialOffer {
      url
    }
  }
`;
